import { endSession } from './session';

// fetch с той же политикой продления токена, что и у axiosInstance: при 401
// один раз обновляем access token и повторяем запрос. Нужен там, где axios не
// подходит — например, для чтения SSE-потока ассистента.

function apiBase() {
  return process.env.REACT_APP_API_URL || '';
}

let pendingRefresh = null;

// Параллельные запросы должны делить одно обновление, иначе второй из них
// отправит уже отозванный refresh-токен и разлогинит пользователя.
function refreshAccessToken() {
  if (!pendingRefresh) {
    pendingRefresh = fetch(`${apiBase()}/refresh-token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: '{}',
    })
      .then(async (response) => {
        const body = await response.json().catch(() => ({}));
        if (!response.ok || !body.accessToken) {
          throw new Error('refresh_failed');
        }
        localStorage.setItem('authToken', body.accessToken);
        return body.accessToken;
      })
      .finally(() => {
        pendingRefresh = null;
      });
  }
  return pendingRefresh;
}

export async function authFetch(path, options = {}) {
  const send = (token) => fetch(`${apiBase()}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      ...(options.headers || {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  const response = await send(localStorage.getItem('authToken'));
  if (response.status !== 401) return response;

  let token;
  try {
    token = await refreshAccessToken();
  } catch (err) {
    endSession();
    throw new Error('unauthorized');
  }
  return send(token);
}

export default authFetch;
